import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Preference } from '../../../../avisDePub/preferences-avis-de-pub/model/preference';
import { Step3 } from '../../../../shared/models/component-messages/mapaRE/step3';
import { PreferenceType } from '../../../../shared/models/enum/preferenceType';
import { ArrayPopTools } from '../../../../shared/services/array-pop-tools';
import { TypeCPVClass } from '../models/TypeCPVClass';
@Component({
  selector: 'app-typeCPV-class',
  templateUrl: './typeCPV-class.component.html'
})
export class TypeCPVClassComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeCPVClass';
  @Input() parentForm: FormGroup;
  @Input() disabled: boolean;
  @Input() objetComplementaire: TypeCPVClass;
  @Input() displayStar: boolean;

  @Output() preferenceSelected = new EventEmitter<Preference>();

  public typeCpv = PreferenceType.CODES_CPV;

  public step3 = new Step3();

  constructor() { }

  public ngOnInit() {
  }

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  chargeDonneePreference(preference: Preference) {
    this.preferenceSelected.emit(preference);
  }


}

